
function IssueActivitiesCtrl(TranslationService, ToastService, HelpdeskService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();


    ctrl.showField = function (fieldName) {
        return HelpdeskService.showCreditNoteField(ctrl.issue, fieldName);
    };

    ctrl.isNull = function (value) {
        if (value === null) {
            return true
        } else {
            return false
        }

    }
}

IssueActivitiesCtrl.$inject = ['TranslationService', 'ToastService', 'HelpdeskService'];

seedWebApp.component('issueActivities', {
    controller: IssueActivitiesCtrl,
    controllerAs: 'ctrl',
    bindings: {
        loading: '<',
        issue: '<',
        activities: '<',
        stages: '<'
    },
    templateUrl: '/SPA/helpdesk/issueActivities.html' + seedWebApp.buildVersion
});